module.exports = __webpack_public_path__ + "files/SPIADI2026 - NÉO INF ADI - Fiche.9220a62a386af872980a7ddc0d40c2d3.pdf";